import React from "react";
import HeroAlternative from "../../components/HeroAlternative/Hero";
import AlternatingImageText from "../../components/AlternatingImageText/AlternatingImageText";
import ServicesSection from "../../components/ServicesSection/ServicesSection";
import Contact from "../../components/Contact/Contact";

export default function Immigration() {
  // Data for ServicesSection
  const customSections = [
    {
      title: "Immigration Documentation",
      description: `In collaboration with relevant government agencies and ministries we can facilitate all your applications for Visa on Arrival (VOA), Resident Permits, Work Permits, and the related applications such as Multi-entry Permits and the renewal of Permits; in a timely and efficient manner.`,
      imageSrc: "/documents.jpg",
      imageAlt: "Project Management Office dashboard and team collaboration"
    },
    {
      title: "Dedicated Executive Support",
      description: `We will provide your organisation with a dedicated executive who  will be responsible for your company and your employees requirements; including receiving you at the airport and hand delivery of all confidential and personal documents.`,
      imageSrc: "/it_support.jpg",
      imageAlt: "Project audit analysis and reporting"
    }
  ];

  return (
    <>
      <HeroAlternative 
        title="Corporate Immigration Services"
        description={`As a solutions and services provider our prime objective in our Immigration Services - to make entering, working, and living in Liberia a seamless and pains free process.
        \n At all times we will adhere to our core values – trustworthy, reliability and professionalism.`}
        imageSrc="/immigration_support.jpg"
      />
      
      <AlternatingImageText 
        sections={customSections}
        backgroundColor="light"
      />
      
      <Contact />
    </>
  );
}